import {
  List,
  Datagrid,
  ExportButton,
  TopToolbar,
  FunctionField,
  WrapperField,
} from "react-admin";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import { HiOutlineLockClosed } from "react-icons/hi";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { RaRowActions } from "../../components/RaRowActions";
import { ListPageIndicator } from "../../components/TablePageIndicator";
import { determineUserReadableRole } from "../users/UserUtils";
import { colors, radius, shadows } from "../../data/tokens";
import { isPlainObject, isSecretKey, settingMeta } from "./system-settings-util";

// Estilo compacto de tabela — espelho do datagridSx das demais listas
const datagridSx = {
  "& .RaDatagrid-headerCell": {
    fontSize: 11.5,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: colors.textMuted,
    backgroundColor: colors.bgSubtle,
    paddingTop: 1,
    paddingBottom: 1,
  },
  "& .RaDatagrid-rowCell": { paddingTop: 0.75, paddingBottom: 0.75 },
};

export const SystemSettingList = () => {
  const isAdmin =
    determineUserReadableRole(localStorage.getItem("roles")) === "admin";

  const ListActions = () => (
    <TopToolbar sx={{ alignItems: "center" }}>
      <ExportButton />
      {/* navegação ancorada à direita; botões ficam à esquerda */}
      <span style={{ marginLeft: "auto", display: "flex" }}>
        <ListPageIndicator />
      </span>
    </TopToolbar>
  );

  return (
    <>
      <PageTopBreadcrumb
        title="Configurações de Sistema"
        firstPath="/#/system-settings/crud"
        actionType="create"
      />
      <List
        title=" "
        // Sem busca de propósito: a tela tem pouquíssimos itens (hoje,
        // só o SMTP) — mesma decisão das telas de Categorias
        actions={<ListActions />}
        perPage={25}
        queryOptions={{ keepPreviousData: true }}
        sx={{
          // Mesmo padrão visual das demais listas do painel
          "& .RaList-main": {
            backgroundColor: colors.white,
            borderRadius: `${radius.lg}px`,
            boxShadow: shadows.card,
            padding: "12px 20px 8px",
          },
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
          "& .RaList-actions .MuiToolbar-root": {
            position: "static",
            gap: 1,
            width: "100%",
            justifyContent: "flex-start",
            minHeight: "auto !important",
            paddingBottom: 1,
          },
        }}
      >
        {/* Sem seleção em massa: excluir configuração de sistema em lote
            é um risco desnecessário — a exclusão individual continua */}
        <Datagrid rowClick="show" sx={datagridSx} bulkActionButtons={false}>
          <FunctionField
            label="Configuração"
            sortBy="name"
            render={(record: any) => {
              const meta = settingMeta(record.name);
              return (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                  {/* Ícone lateral no mesmo padrão dos cartões de KPI */}
                  <Box
                    sx={{
                      backgroundColor: colors.bgContent,
                      borderRadius: `${radius.sm}px`,
                      padding: 0.75,
                      display: "flex",
                      color: colors.primary,
                      flexShrink: 0,
                    }}
                  >
                    <meta.Icon size={18} />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: 13.5,
                        fontWeight: 600,
                        color: colors.primaryDark,
                      }}
                    >
                      {meta.label}
                    </Typography>
                    <Typography
                      sx={{ fontSize: 11.5, color: colors.textMuted }}
                    >
                      {record.name}
                    </Typography>
                  </Box>
                </Box>
              );
            }}
          />
          {/* Só os NOMES dos campos — a listagem antiga imprimia o JSON
              inteiro, com a senha do SMTP em texto puro na tela */}
          <FunctionField
            label="Campos"
            render={(record: any) =>
              isPlainObject(record.value) ? (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {Object.keys(record.value).map((key) => (
                    <Chip
                      key={key}
                      size="small"
                      variant="outlined"
                      color={isSecretKey(key) ? "warning" : "default"}
                      label={key}
                      icon={
                        isSecretKey(key) ? (
                          <HiOutlineLockClosed size={12} />
                        ) : undefined
                      }
                      sx={{ "& .MuiChip-icon": { marginLeft: "6px" } }}
                      title={
                        isSecretKey(key)
                          ? "Valor protegido — visível na ficha com \"Mostrar segredos\""
                          : undefined
                      }
                    />
                  ))}
                </Box>
              ) : (
                <Chip size="small" variant="outlined" label="JSON" />
              )
            }
          />
          {/* Ações visíveis no lugar do menu ⋮ */}
          <WrapperField label="Ações" textAlign="right">
            <RaRowActions show edit={isAdmin} del={isAdmin} />
          </WrapperField>
        </Datagrid>
      </List>
    </>
  );
};
